import Cookies from 'js-cookie';

import { ACTIVE_VEHICLE_ID_COOKIE } from '@constants';

export const getActiveVehicle = (activeVehicle, vehicles) => {
  const selectedVehicleId = Cookies.get(ACTIVE_VEHICLE_ID_COOKIE);

  let selectedVehicle = vehicles.find(vehicle =>
    vehicle.isOrdered
      ? vehicle.order.orderId === selectedVehicleId
      : vehicle.reservation.reservationId === selectedVehicleId
  );

  if (!selectedVehicle) {
    selectedVehicle = vehicles[activeVehicle?.index];
  }
  return selectedVehicle;
};

export const getActiveVehicleID = () => Cookies.get(ACTIVE_VEHICLE_ID_COOKIE);

export const setActiveVehicle = vehicle => {
  const activeVehicleId = vehicle.isOrdered
    ? vehicle.order.orderId
    : vehicle.reservation.reservationId;
  Cookies.set(ACTIVE_VEHICLE_ID_COOKIE, activeVehicleId);
};

export const clearActiveVehicle = function () {
  Cookies.remove(ACTIVE_VEHICLE_ID_COOKIE);
};
